<template>
    <div id="profile-page" v-if="uid">
        <!-- PROFILE HEADER -->
        <Header v-if="dataProfile" :user="dataProfile" />
        <div class="vx-row">
            <div class="vx-col w-full lg:w-1/4" v-if="dataProfile" >
                <div v-if="dataProfile.role.is_student &&  study_plans.length">
                    <AboutUser  v-for="study in study_plans" :key="study.uid" :uid="uid"  :studyPlan="study"/>
                </div>
                <div v-else-if="dataProfile.role.is_teacher &&  study_plans.length">
                    <LeftSideTeacher  v-for="study in study_plans" :key="study.uid" :uid="uid"  :info="study"/>
                </div>
            </div>
            <div class="vx-col w-full lg:w-3/4">
                <div class="user_profile_container">
                    <vue-headful :title="profileTitle(dataProfile)" />
                    <vs-collapse type="margin" v-if="dataProfile">
                        <template v-for="(parent, parentIndex) in profileCascade">
                            <!-- Проверяем что данные у массивов не пустые -->
                            <template v-if="checkArrayData(parent)">
                                <div class="flex relative" :key="parentIndex">
                                    <vs-collapse-item class="collapse_item w-full mt-0">
                                        <!-- Заголовок коллапса -->
                                        <div slot="header">
                                            <h4 class="text-sm lg:text-xl">{{$t(parent.title_i18n)}}</h4>
                                        </div>
                                        <vx-card no-shadow class="profile_block">
                                            <template v-for="(item, childIndex) in parent.list">
                                                <!-- Если это массив -->
                                                <template v-if="item.thisArray">
                                                    <!-- Если данные не пустые -->
                                                    <div v-if="dataProfile[item.key_i18n] || dataProfile[item.key_value] && dataProfile[item.key_value].length"
                                                        :key="`c_${childIndex}`">
                                                                <template
                                                                    v-for="(subItem, subIndex) in dataProfile[item.key_value]">
                                                                    <h5 class="mb-5 sub-header-title text-primary"
                                                                        :key="`sc_${subIndex}`">{{ $t(item.key_i18n) }}</h5>
                                                                    <template v-for="(elem, elemIndex) in item.list">
                                                                        <template v-if="subItem[elem.key_i18n]">

                                                                            <div class="item justify-between lg:flex items-center"  :key="`${elemIndex}_${subIndex}`">
                                                                                <div class="item_content lg:flex items-center">
                                                                                    <div class="label">{{$t(elem.key_i18n)}}:
                                                                                    </div>
                                                                                    <div class="val" v-if="elem.thisObj">
                                                                                        {{ entries(subItem[elem.key_i18n],elem.key_obj) }}
                                                                                    </div>
                                                                                    <div class="val" v-else>
                                                                                        {{ elem.renderHandler ? elem.renderHandler(subItem[elem.key_i18n]) : subItem[elem.key_i18n] }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </template>
                                                                    </template>
                                                                </template>
                                                            </div>
                                                        </template>

                                                <!-- Если это не массив -->
                                                <template v-else>
                                                    <!-- Если данные не пустые -->
                                                    <template
                                                        v-if="dataProfile[item.key_value] || dataProfile[item.key_i18n]">
                                                        <!-- Условие при котором не будет отображаться middle_name_en -->
                                                        <template v-if="dataProfile.middle_name_en && $i18n.locale == 'en'">
                                                            <div class="item justify-between lg:flex items-center"
                                                                :key="`c_${childIndex}`">
                                                                <div class="item_content lg:flex items-center">
                                                                    <div class="label">{{$t(item.key_i18n)}}:</div>
                                                                    <div class="val">
                                                                        <!-- Проверяем по каким ключам брать данные -->
                                                                        <template v-if="item.key_value">
                                                                            {{ item.renderHandler ? item.renderHandler(dataProfile[item.key_value]) : dataProfile[item.key_value] }}
                                                                        </template>
                                                                        <template v-else>
                                                                            <template>
                                                                                {{ item.renderHandler ? item.renderHandler(dataProfile[item.key_i18n]) : dataProfile[item.key_i18n] }}
                                                                            </template>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- </template> -->
                                                        </template>
                                                        <template v-else>
                                                            <div class="item justify-between lg:flex items-center" :key="`c_${childIndex}`">
                                                                <div class="item_content lg:flex items-center">
                                                                    <div class="label">{{$t(item.key_i18n)}}:</div>
                                                                    <div class="val">
                                                                        <!-- Проверяем по каким ключам брать данные -->
                                                                        <template v-if="item.key_value">
                                                                            {{ item.renderHandler ? item.renderHandler(dataProfile[item.key_value]) : dataProfile[item.key_value] }}
                                                                        </template>
                                                                        <template v-else>
                                                                            <template>
                                                                                {{ item.renderHandler ? item.renderHandler(dataProfile[item.key_i18n]) : dataProfile[item.key_i18n] }}

                                                                            </template>
                                                                        </template>
                                                                    </div>
                                                                </div>

                                                                <!-- Кнопка скрытия/показа поля -->
                                                                <!-- <vx-tooltip :text="toltipText(item)" class="mt-2 lg:mt-0 lg:pl-3" v-if="checkShow(item)">
                                                                    <vs-switch
                                                                        v-model="allowed_items[item.key_value ? item.key_value : item.key_i18n]"
                                                                        icon-pack="feather"
                                                                        vs-icon-off="icon-eye-off"
                                                                        vs-icon-on="icon-eye" />
                                                                </vx-tooltip> -->
                                                            </div>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </vx-card>
                                    </vs-collapse-item>

                                </div>
                            </template>
                        </template>
                    </vs-collapse>
                    <!-- Пустышка для loader -->
                    <div class="profile_loader"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './components/Header';
import LeftSideTeacher from './components/LeftSideTeacher';
import AboutUser from '@/pages/Home/Desktop/components/AboutUser'
import axios from '@/configs/Axios'

export default {
    components:{
        Header,AboutUser,LeftSideTeacher
    },
    data() {
        return {
            allowed_items: null,
            initial_statuses: null,
            dataProfile:null,
            allData: [ // Эти данные видны всем
                {
                    title_i18n: 'personal_information',
                    list: [{
                        key_i18n: 'name',
                        key_value: 'firstName'
                    },
                    {
                        key_i18n: 'first_name',
                        key_value: 'lastName'
                    },
                    {
                        key_i18n: 'middle_name',
                        key_value: 'middleName'
                    },
                    {
                       key_i18n_en: 'middle_Name_en',
                       key_value_en: 'middle_name_en'
                    },
                    {
                        key_i18n: 'date_of_brith',
                        key_value: 'birth_date',
                        renderHandler: this.dateReplace
                    },
                    {
                        key_i18n: 'birth_place'
                    },
                    {
                        key_i18n: 'nationality'
                    },
                    {
                        key_i18n: 'citizenship'
                    },
                    {
                        key_i18n: 'marital_status'
                    },
                    {
                        key_i18n: 'gender'
                    },
                    {
                        key_i18n: 'social_links',
                        key_value: 'social_links',
                        thisArray: true,
                        list: [{
                            key_i18n: 'social_link'
                        },
                        {
                            key_i18n: 'social_web_type',
                            key_value: 'social_web_type',
                            thisObj: true,
                            key_obj: 1
                        },
                        ]
                    },
                    {
                        key_i18n: 'iin'
                    }
                    ]
                },
                {
                    title_i18n: 'id_documents',
                    list: [{
                        key_i18n: 'document',
                        key_value: 'identity_documents',
                        thisArray: true,
                        list: [{
                            key_i18n: 'document_type'
                        },
                        {
                            key_i18n: 'serial_number'
                        },
                        {
                            key_i18n: 'number'
                        },
                        {
                            key_i18n: 'given_date',
                            renderHandler: this.dateReplace
                        },
                        {
                            key_i18n: 'validity_date',
                            renderHandler: this.dateReplace
                        },
                        {
                            key_i18n: 'issued_by'
                        },
                        ]
                    }, ]
                },
                {
                    title_i18n: 'contact_information',
                    list: [{
                        key_i18n: 'address'
                    },
                    {
                        key_i18n: 'phone'
                    },
                    {
                        key_i18n: 'email'
                    },
                    {
                        key_i18n: 'skype'
                    },
                    {
                        key_i18n: 'extra_data'
                    },
                    ]
                },
                {
                    title_i18n: 'education',
                    list: [{
                        key_i18n: 'document',
                        key_value: 'educations',
                        thisArray: true,
                        list: [{
                            key_i18n: 'edu_type'
                        },
                        {
                            key_i18n: 'document_type'
                        },
                        {
                            key_i18n: 'serial_number'
                        },
                        {
                            key_i18n: 'number'
                        },
                        {
                            key_i18n: 'given_date',
                            renderHandler: this.dateReplace
                        },
                        {
                            key_i18n: 'institute'
                        },
                        ]
                    }]
                },
                {
                    title_i18n: 'interest',
                    list: [{
                        key_i18n: 'interests',
                        key_value: 'interests',
                        thisArray: true,
                        list: [{
                            key_i18n: 'content'
                        }, ]
                    }]
                },
                {
                    title_i18n: 'attainment',
                    list: [{
                        key_i18n: 'achievements',
                        key_value: 'achievements',
                        thisArray: true,
                        list: [{
                            key_i18n: 'achievement_type'
                        },
                        {
                            key_i18n: 'level'
                        },
                        {
                            key_i18n: 'content'
                        }
                        ]
                    }]
                },
                {
                    title_i18n: 'academic_titles',
                    key_value: 'academic_ranks',
                    list: [
                        { key_i18n: 'academic_ranks' },
                        {
                            key_i18n: 'academic_degree'
                        },
                        {
                            key_i18n: 'academic_rank'
                        },
                    ]
                },
                {
                    title_i18n: 'hr_information',
                    list: [
                        {
                            key_i18n: 'work_experience_year'
                        },
                        {
                            key_i18n: 'work_experience_month'
                        },
                        {
                            key_value: 'positions',
                            thisArray: true,
                            list: [
                                {
                                    key_i18n: 'position'
                                },
                                {
                                    key_i18n: 'cathedra'
                                },
                                {
                                    key_i18n: 'study_year'
                                },
                                {
                                    key_i18n: 'work'
                                },
                            ]
                        }
                    ]
                },
                {
                    title_i18n: 'emergency_contacts',
                    list: [
                        {
                            key_value: 'emergency_contacts',
                            thisArray: true,
                            list: [
                                { key_i18n: 'contact_person' },
                                { key_i18n: 'relation_degree' },
                                { key_i18n: 'phone' },
                                { key_i18n: 'email' },
                                { key_i18n: 'address' }
                            ]
                        },
                    ]
                },
            ],
            onlyUserData: [ // Эти данные видны только самому пользователю
            ],
            profileCascade: [],

            study_plans:[],
        }
    },
    computed: {
        uid() {
            return this.$route.query.id ? this.$route.query.id : '';
        },

        showButtonSave() {
            if (this.allowed_items) {
                let length_list = 0;
                for (let key in this.allowed_items) {
                    if (this.allowed_items[key] === this.initial_statuses[key])
                        length_list += 1;
                }
                return length_list !== Object.keys(this.initial_statuses).length
            } else
                return false
        }
    },

    methods: {
        hasOnlyStudentRole(){
            let roles = this.$store.state.user.roles
            let keys = Object.keys(this.$store.state.user.roles)
            let actual_roles = []
            keys.forEach((key)=>{
                if(roles[key]){
                    actual_roles.push(key)
                }
            })

            if (actual_roles.length === 1 && actual_roles.includes('IS_STUDENT'.toLowerCase())){
                return true
            }else{
                return false
            }
        },
        profileTitle(data) {
            if (this.$route.name === 'profile'){
                return this.$t('my_profile')
            }else{
                return data.full_name_with_id ? data.full_name_with_id : this.$t('profile_user')
            }
        },
        entries(obj, key) {
            return Object.entries(obj)[key][1];
        },
        checkArrayData(item) {
            if (item.list[0].thisArray) {
                // Если это массив, проверяем есть ли у него данные для вывода
                if (this.dataProfile[item.list[0].key_value] && this.dataProfile[item.list[0].key_value].length)
                    return true
                else return false
            } else {
                // Если это объект. проверяем данные на пустоту
                let checkArray = []

                item.list.forEach(elem => {
                    const key = elem.key_value ? elem.key_value : elem.key_i18n
                    if (this.dataProfile[key]) checkArray.push(true)
                })

                if (checkArray.length)
                    return true
                else
                    return false
            }
        },
        dateReplace(date) {
            // Заменяем дату там где она выводиться
            return this.$moment(date).format('DD-MM-YYYY')
        },
        async getUserInfo() {
            // Запрашиваем информацию о пользователе
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: ".profile_loader",
                        scale: 0.45
                    })
                })

                const {
                    data
                } = await this.$http.get(`/user/profile/${ this.uid }/`)

                if (typeof data === 'object') {
                    // Если мы запрашиваем инфу текущего пользователя, добавляем в массив вывода личные данные
                    if (data.profileId === this.uid) {
                        this.profileCascade = this.profileCascade.concat(this.onlyUserData)
                        // Записываем данные о скрытых/открытых полях
                        // this.allowed_items = {
                        //     ...data.fields_to_show[0]
                        // }
                        // this.initial_statuses = {
                        //     ...data.fields_to_show[0]
                        // }
                    }

                    // console.log(data, 'data')

                    this.dataProfile = data


                    await this.getAboutUser();

                }
            } catch (e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger',
                })
            } finally {
                this.$vs.loading.close(".profile_loader > .con-vs-loading")
            }
        },

        async getAboutUser(){
            var role = this.dataProfile.role
            if(role.is_student){
                await axios.get(`/user/my_study_plans_version2/?profile=${this.uid}`)
                    .then(res => {
                        this.study_plans = res.data;
                    })
                    .catch((error) => { reject(error) })
            }
            else if(role.is_teacher){
                await axios.get(`/widgets/about_me/?profile=${this.uid}`)
                    .then(res => {
                        this.study_plans = res.data;
                    })
                    .catch((error) => { reject(error) })

            }

        }
    },


    mounted() {

    },
    async created() {

        if(this.hasOnlyStudentRole()){
            await this.$router.push({name: 'desktop'})
            return
        }
        // Подставляем каскад данных о пользователе для вывода информации по ним
        this.profileCascade = this.allData
        // Запрашиваем данные о пользователе
        await this.getUserInfo();

        // Удаляет middleName если его нет на англ языке и сайт на англ
        if(this.dataProfile && this.dataProfile.middle_name_en == null && this.$i18n.locale == "en") {
            this.dataProfile.middleName = ""
        }
    }
}

</script>

<style lang="scss" scoped>
    .user_profile_container {
        .save_btn {
            position: relative;

            .con-vs-loading {
                position: absolute;
            }
        }

        .vs-collapse-item {
            background: #ffffff;
        }

        .vs-collapse.margin {
            padding: 0px;
        }

        .profile_loader {
            position: relative;
            min-height: 50px;

            .con-vs-loading {
                position: absolute;
            }
        }

        .profile_block {
            .sub-header-title {
                &:not(:first-child) {
                    padding-top: 15px;
                }
            }

            .item {
                &:not(:last-child) {
                    margin-bottom: 13px;
                    padding-bottom: 13px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                }

                .label {
                    font-weight: bold;
                    padding-right: 10px;
                    min-width: 280px;
                }
            }
        }

        @media only screen and (max-width: 900px) {
            .collapse_switch {
                position: absolute;
                z-index: 5;
                top: 10px;
                right: 5px;
            }
        }
    }
</style>
